import { Actions } from "src/types";

import type { NavigationLink } from "./utils/getCurrentSelectionLinks";

export const DEFAULT_NAVIGATION_LINKS: NavigationLink[] = [
  { label: "About", action: { kind: Actions.None }, noCustomization: true },
  { label: "Speakers", action: { kind: Actions.None }, noCustomization: true },
  { label: "Schedule", action: { kind: Actions.None }, noCustomization: true },
  { label: "Sponsors", action: { kind: Actions.None }, noCustomization: true },
  { label: "Expo", action: { kind: Actions.None }, noCustomization: true },
];
